import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
	locales: ["fr", "en"],
	defaultLocale: "fr",
	localePrefix: "never",
});
